import indexViewRouteRes from './outSide'
import loginViewRouteRes from './login'
import homeViewRouteRes from './home'
import informationViewRouteRes from './information'
import messageViewRouteRes from './message'
import recordRes from './record'
import userRes from './user'
import settingRes from './setting'
import healthViewRouteRes from './health'


export default [
  ...indexViewRouteRes,
  ...loginViewRouteRes,
  ...homeViewRouteRes,
  ...informationViewRouteRes,
  ...messageViewRouteRes,
  ...recordRes,
  ...userRes,
  ...settingRes,
  ...healthViewRouteRes
]



// WEBPACK FOOTER //
// ./src/router/mapping/index.js